import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {filter, map, mergeMap} from 'rxjs/operators';
import {UserService} from '../../user/user.service';
import {BrandingService} from '../../shared/services/branding/branding.service';
import {LanguageService} from '../../shared/services/language/language.service';
import * as companyInfoActions from '../actions/company-info.action';
import {DbResponse} from '../../shared/interceptors/db-response';

@Injectable()
export class CompanyInfoEffects {

  loadCompanyInfo$ = createEffect(() => this._actions$.pipe(
    ofType(companyInfoActions.LOAD_COMPANY_INFO),
      mergeMap(() => {
          return this._userService.getCompanyInfo()
              .pipe(
                  filter((response: DbResponse) => !!response),
                  map((response: DbResponse) => {
                      if (response.success) {
                          // Apply brand colors when company info is successfully loaded
                          if (response.data && response.data.branding && response.data.branding.cache_color) {
                              this._brandingService.applyCustomBrandColor(response.data.branding.cache_color);
                          }
                          return new companyInfoActions.LoadCompanyInfoSuccess(response.data);
                      } else {
                          return new companyInfoActions.LoadCompanyInfoFail(response.message || 'Failed to load company info');
                      }
                  })
              );
      })
  ));

  constructor(
    private _actions$: Actions,
    private _userService: UserService,
    private _brandingService: BrandingService,
    private _languageService: LanguageService
  ) {}
}
